<template>
	<div>
        <div :id="'id'+id" :style="tabulator ? 'height:30px' : 'height:100px'">
            <span v-if="tabulator">
                <b-button v-b-modal="'i-'+ id" variant="link">
                    <draggable v-if="edit" style="display:inline-block" @change="move" :group="'images'" :list="images" class="list-group" handle=".handle">
                        <span v-for="(image, idx) in images.slice(0, 10)" :key="idx">
                            <img @load="onImgLoad" :id="id+'-t-' + idx" :class="'c' + id + ' handle'" :src="image.url" :style="'max-height: 30px;margin-right:10px; border:' + (((image.state && image.state == 'blacklist') || (!image.state && blacklist.includes(image.domain))) ? 'red 3px solid' : ((image.state && image.state == 'whitelist') || (!image.state && whitelist.includes(image.domain))) ? 'green 3px solid' : 'black 0px solid')" />
                            <!-- <b-tooltip custom-class="long-tooltip" :target="id+'-t-' + idx">{{ JSON.stringify(image, null, "    ") }}
                            </b-tooltip> -->
                        </span>
                    </draggable>
                    <span v-else>
                        <span v-for="(image, idx) in images.slice(0, 10)" :key="idx">
                            <img @load="onImgLoad" :id="id+'-t-' + idx" :class="'c' + id" :src="image.url" :style="'max-height: 30px;margin-right:10px; border:' + (((image.state && image.state == 'blacklist') || (!image.state && blacklist.includes(image.domain))) ? 'red 3px solid' : ((image.state && image.state == 'whitelist') || (!image.state && whitelist.includes(image.domain))) ? 'green 3px solid' : 'black 0px solid')" />
                            <!-- <b-tooltip custom-class="long-tooltip" :target="id+'-t-' + idx">{{ JSON.stringify(image, null, "    ") }}
                            </b-tooltip> -->
                        </span>
                    </span>
                    <span :class="'c' + id" v-show="images.length > 10">+ {{images.length - 10}} images</span>
                </b-button>
                <b-button v-if="edit" v-b-modal="'edit-i-'+ id" variant="link">
                    <i class="fas fa-plus"></i>
                </b-button>
            </span>
            <div v-else>
                <draggable v-if="edit" style="display:inline-block" @change="move" :group="'images'" :list="images" class="list-group" handle=".handle">
                    <span v-for="(image, idx) in images.slice(0, 10)" :key="idx">
                        <img :id="id+'-i2-' + idx" @load="onImgLoad" :class="'c' + id + ' handle'" :src="image.url" :style="'max-height: 100px;margin-right:10px; margin-bottom:10px; border:' + (((image.state && image.state == 'blacklist') || (!image.state && blacklist.includes(image.domain))) ? 'red 3px solid' : ((image.state && image.state == 'whitelist') || (!image.state && whitelist.includes(image.domain))) ? 'green 3px solid' : 'black 0px solid')" />
                        <b-tooltip custom-class="long-tooltip" :target="id+'-i2-' + idx">{{ JSON.stringify(image, null, "    ") }}</b-tooltip>
                    </span>
                </draggable>
                <span v-else>
                    <span v-for="(image, idx) in images.slice(0, 10)" :key="idx">
                        <img :id="id+'-i2-' + idx" @load="onImgLoad" :class="'c' + id" :src="image.url" :style="'max-height: 100px;margin-right:10px; margin-bottom:10px; border:' + (((image.state && image.state == 'blacklist') || (!image.state && blacklist.includes(image.domain))) ? 'red 3px solid' : ((image.state && image.state == 'whitelist') || (!image.state && whitelist.includes(image.domain))) ? 'green 3px solid' : 'black 0px solid')" />
                        <b-tooltip custom-class="long-tooltip" :target="id+'-i2-' + idx">{{ JSON.stringify(image, null, "    ") }}
                            </b-tooltip>
                    </span>
                </span>
                <b-button v-if="images.length > 0 && images[0].url" v-b-modal="'i-'+ id" variant="link"><span :class="'c' + id" v-if="images.length > 10">+ {{images.length - 10}} images </span><i class="fas fa-search-plus"></i></b-button>
                <b-button v-if="edit" v-b-modal="'edit-i-'+ id" variant="link">
                    <i class="fas fa-plus"></i>
                </b-button>
            </div>
        </div>
        <b-modal :title="'Images'" size="xl" ok-only :id="'i-'+ id" @show="open = true" @hidden="open = false;">
            <b-button variant="link" @click="list = !list">{{!list ? "Liste" : "Images"}}</b-button>
            <div v-if="open">
                <b-button v-if="edit" v-b-toggle="'edit-ci-'+ id" variant="link">
                    <i class="fas fa-plus"></i>
                </b-button>
                <b-collapse :title="'Ajouter une image'" size="xl" ok-only :id="'edit-ci-'+ id">
                    Url
                    <b-input v-model="url"></b-input>
                    <br />
                    <b-button @click="add">Ajouter</b-button>
                </b-collapse>
                <br />
                <draggable v-if="edit" style="display:inline-block" @change="move" :group="'images'" :list="images" class="list-group" handle=".handle">
                    <div v-for="(image, idx) in images" :key="idx">
                        <span :class="'handle'" :style="'color:' + (((image.state && image.state == 'blacklist') || (!image.state && blacklist.includes(image.domain))) ? 'red' : ((image.state && image.state == 'whitelist') || (!image.state && whitelist.includes(image.domain))) ? 'green' : 'inherit')">{{idx + 1}}/{{images.length}} - {{image.link || image.url}} - {{image.width || "non défini"}} x {{image.height || "non défini"}}</span>
                        <span v-show="black_white_lists && black_white_lists_edit && !list">
                            <b-button :style="'color:' + (((image.state && image.state == 'whitelist') || (!image.state && whitelist.includes(image.domain))) ? 'green' : '')" variant="link" @click="addList(image.domain, 'whitelist')">Whitelist</b-button>
                            <b-button :style="'color:' + (((image.state && image.state == 'blacklist') || (!image.state && blacklist.includes(image.domain))) ? 'red' : '')" variant="link" @click="addList(image.domain, 'blacklist')">Blacklist</b-button>
                        </span>
                        <b-button variant="link" @click="deleteList(idx)">Supprimer</b-button>
                        <br v-show="!list" />
                        <img :class="'handle'" v-show="!list" :id="id+'-i-' + idx" :src="image.url" :style="'max-width:100%;margin-bottom:5px;border:' + (((image.state && image.state == 'blacklist') || (!image.state && blacklist.includes(image.domain))) ? 'red 3' : ((image.state && image.state == 'whitelist') || (!image.state && whitelist.includes(image.domain))) ? 'green 3' : 'black 1') + 'px solid'"/>
                        <b-tooltip custom-class="long-tooltip" :target="id+'-i-' + idx">{{ JSON.stringify(image, null, "    ") }}
                            </b-tooltip>
                        <br />
                    </div>
                </draggable>
                <span v-else>
                    <div v-for="(image, idx) in images" :key="idx">
                        <span :style="'color:' + (((image.state && image.state == 'blacklist') || (!image.state && blacklist.includes(image.domain))) ? 'red' : ((image.state && image.state == 'whitelist') || (!image.state && whitelist.includes(image.domain))) ? 'green' : 'inherit')">{{idx + 1}}/{{images.length}} - {{image.link || image.url}} - {{image.width || "non défini"}} x {{image.height || "non défini"}}</span>
                        <span v-show="black_white_lists && black_white_lists_edit && !list">
                            <b-button :style="'color:' + (((image.state && image.state == 'whitelist') || (!image.state && whitelist.includes(image.domain))) ? 'green' : '')" variant="link" @click="addList(image.domain, 'whitelist')">Whitelist</b-button>
                            <b-button :style="'color:' + (((image.state && image.state == 'blacklist') || (!image.state && blacklist.includes(image.domain))) ? 'red' : '')" variant="link" @click="addList(image.domain, 'blacklist')">Blacklist</b-button>
                        </span>
                        <br v-show="!list" />
                        <img :class="'handle'" v-show="!list" :id="id+'-i-' + idx" :src="image.url" :style="'max-width:100%;margin-bottom:5px;border:' + (((image.state && image.state == 'blacklist') || (!image.state && blacklist.includes(image.domain))) ? 'red 3' : ((image.state && image.state == 'whitelist') || (!image.state && whitelist.includes(image.domain))) ? 'green 3' : 'black 1') + 'px solid'"/>
                        <b-tooltip custom-class="long-tooltip" :target="id+'-i-' + idx">{{ JSON.stringify(image, null, "    ") }}
                            </b-tooltip>
                        <br />
                    </div>
                </span>
            </div>
        </b-modal>
        <b-modal :title="'Ajouter une image'" size="xl" ok-only :id="'edit-i-'+ id">
            Url
            <b-input v-model="url"></b-input>
            <br />
            <b-button @click="add">Ajouter</b-button>
        </b-modal>
 	</div>
</template>

<script>
    import database from "../services/database.js";
    import store from "../store";

	import uniqueId from "lodash.uniqueid";
    import draggable from "vuedraggable";

    var clone = require("clone");

    export default {
        name: "images",
		components: {
            draggable
		},
		props: {
            'source': {},
            'column': {},
            'black_white_lists': {},
            'black_white_lists_edit': {},
            "idx": {},
            "tabulator": {
                default: true
            },
            edit: false,
            index: 0
        },
		data() {
			return {
                id: uniqueId(),
                images: [],
                loaded: 0,
                open: false,
                whitelist: [],
                blacklist: [],
                list: false,
                url: ""
			};
		},
		computed: {
			event() {
				return store.getters.getEvent
			}
		},
		watch: {
            source() {
                this.init();
            },
			event: async function (event) {
                if (this.black_white_lists)
                {
                    if (event == "images_whitelist")
                    {
                        this.whitelist = store.state.images_whitelist;
                    }
                    if (event == "images_blacklist")
                    {
                        this.blacklist = store.state.images_blacklist;
                    }
                }
			}
		},
		methods: {
            async move() {
                this.$emit('update', this.index, this.column, JSON.stringify(this.images));
            },
            async add()
            {
                console.log("add");

                this.loaded = 0;

                var images = this.images;

                images.unshift({
                    url: this.url,
                    domain: this.url.replace(/(.*\/\/.*?\/).*/, '$1')
                });

                this.$emit('update', this.index, this.column, JSON.stringify(images));

                return;
            },
            async deleteList(idx)
            {
                this.images.splice(idx, 1);
                this.$emit('update', this.index, this.column, JSON.stringify(this.images));
            },
            async addList(element, type)
            {
                var _type = null;

                var response = await database.get("select", store.state.client.details.tables_obj.black_white_lists, {
                    select: "*",
                    where: 'element = "' + element + '"'
                });

                if (response.length > 0)
                {
                    for (var i = 0; i < response.length; i++)
                    {
                        await database.get("delete", store.state.client.details.tables_obj.black_white_lists, {
                            where: "id = '" + response[i].id + "'"
                        })
                        _type = response[i].type;
                    }

                    var index = this.blacklist.indexOf(element);
                    if (index != -1)
                    {
                        this.blacklist.splice(index, 1);
                        store.commit("setImagesBlacklist", this.blacklist)
                        await this.$nextTick()
                        store.commit("setEvent", "images_blacklist");
                        await this.$nextTick()
                        store.commit("setEvent", "");
                    }
                    var index = this.whitelist.indexOf(element);
                    if (index != -1)
                    {
                        this.whitelist.splice(index, 1);
                        store.commit("setImagesWhitelist", this.whitelist)
                        await this.$nextTick()
                        store.commit("setEvent", "images_whitelist");
                        await this.$nextTick()
                        store.commit("setEvent", "");
                    }
                }

                if (type && type != _type)
                {
                    var response = await database.get("insert into", store.state.client.details.tables_obj.black_white_lists, {
                        columns: ['element', 'type', 'image', 'youtube'],
                        data: {
                            element: element,
                            type,
                            image: true,
                            youtube: false
                        }
                    });

                    if (type == "blacklist")
                    {
                        this.blacklist.push(element);

                        store.commit("setImagesBlacklist", this.blacklist)
                        await this.$nextTick()
                        store.commit("setEvent", "images_blacklist");
                        await this.$nextTick()
                        store.commit("setEvent", "");

                    }
                    if (type == "whitelist")
                    {
                        this.whitelist.push(element);

                        store.commit("setImagesWhitelist", this.whitelist)
                        await this.$nextTick()
                        store.commit("setEvent", "images_whitelist");
                        await this.$nextTick()
                        store.commit("setEvent", "");
                    }
                }
            },
            onImgLoad()
            {
                var self = this;

                this.loaded++;

                if (this.loaded == this.images.slice(0, 10).length)
                {
                    var elems = document.querySelectorAll(".c" + self.id);
                    var width = 20;
                    for (var i = 0; i < elems.length; i++)
                    {
                        width += elems[i].offsetWidth + 10;
                    }
                    self.$emit('width', width, self.column);
                }
            },
            async init()
            {
                var self = this;

                var source = clone(this.source);

                if (!source)
                    source = "[]";

                var images = [];

                if (source.startsWith("["))
                {
                    source = JSON.parse(source);
                    for (var i = 0; i < source.length; i++)
                    {
                        if (typeof source[i] == "object")
                            images.push(source[i]);
                        else
                            images.push({url: source[i]});
                    }
                }
                else if(source.startsWith("{"))
                {
                    source = JSON.parse(source);
                    images.push(source);
                }
                else
                {
                    images = [{url: source}];
                }

                if (images.length > 0)
                {
                    if ((!images[0].url && images[0].uid) || (images[0].url && !images[0].url.startsWith("h") && images[0].url.length == 36))
                    {
                        var ids = "";
                        for (var i = 0; i < images.length; i++)
                        {
                            if (i > 0)
                                ids += ",";
                            ids += '"' + (images[i].uid || images[i].url) + '"';
                        }

                        var images_obj = {};
                        var _images = await database.get("select", store.state.client.details.tables_obj.characteristic, {
                            select: "*",
                            where: "uid in (" + ids + ") ORDER BY FIELD(uid, " + ids + ")"
                        });

                        for (var i = 0; i < _images.length; i++)
                        {
                            images_obj[_images[i].uid] = JSON.parse(_images[i].data);
                        }

                        for (var i = 0; i < images.length; i++)
                        {
                            if (images_obj[(images[i].uid || images[i].url)])
                            {
                                if (images[i].url && !images[i].url.startsWith("h") && images[i].url.length == 36)
                                {
                                    images[i].uid = images[i].url;
                                }
                                var key = images[i].uid || images[i].url;
                                if (images[i].url)
                                    delete images[i].url;
                                images[i] = Object.assign(images_obj[key], images[i]);
                            }
                        }
                    }
                }

                for (var i = 0; i < images.length; i++)
                {
                    images[i].domain = "";
                    if (images[i].link || images[i].url)
                        images[i].domain = (images[i].link || images[i].url).replace(/(.*\/\/.*?\/).*/, '$1')
                }

                this.images = images;

                if (this.black_white_lists)
                {
                    //console.log(this.idx + " - set black_white_lists")

                    var whitelist = store.state.images_whitelist;
                    var blacklist = store.state.images_blacklist;

                    if (blacklist == null)
                    {
                        if (this.idx == 1)
                        {
                            //console.log("set black_lists - db")
                            var blacklist = [];
                            var response = await database.get("select", store.state.client.details.tables_obj.black_white_lists, {
                                select: "*",
                                where: 'type = "blacklist" and image is true'
                            });

                            //console.log(response)

                            for (var i = 0; i < response.length; i++)
                            {
                                blacklist.push(response[i].element);
                            }

                            store.commit("setImagesBlacklist", blacklist)
                            await this.$nextTick()
                            store.commit("setEvent", "images_blacklist");
                            await this.$nextTick()
                            store.commit("setEvent", "");
                        }
                    }
                    else
                    {
                        this.blacklist = blacklist;
                    }

                    if (whitelist == null)
                    {
                        if (this.idx == 1)
                        {
                            //console.log("set white_lists - db")

                            var whitelist = [];
                            var response = await database.get("select", store.state.client.details.tables_obj.black_white_lists, {
                                select: "*",
                                where: 'type = "whitelist" and image is true'
                            });

                            for (var i = 0; i < response.length; i++)
                            {
                                whitelist.push(response[i].element);
                            }

                            store.commit("setImagesWhitelist", whitelist)
                            await this.$nextTick()
                            store.commit("setEvent", "images_whitelist");
                            await this.$nextTick()
                            store.commit("setEvent", "");
                        }
                    }
                    else
                    {
                        this.whitelist = whitelist;
                    }
                }
            }
		},
		mounted: async function () {
            this.init();
		},
	};
</script>

<style>
.tooltip-inner {
    white-space: pre-wrap;
}
</style>
